'use client';

import React, { useState } from 'react';

import IconWithBackground from '@/components/icon-with-background';
import { iconNames } from '@/components/icons';
import { COLORS } from '@/constants';

import { Tooltip as TooltipRoot, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

type HelpIconTooltipProps = {
  content: React.ReactNode;
};

function stopPropagation(e: React.MouseEvent | React.PointerEvent | React.TouchEvent) {
  e.stopPropagation();
}

export const HelpIconTooltip = ({ content }: HelpIconTooltipProps) => {
  const [open, setOpen] = useState(false);

  return (
    <TooltipProvider delayDuration={300}>
      <TooltipRoot open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <span className="relative inline-block size-6">
            <span
              className="absolute left-1/2 top-1/2 size-12 -translate-x-1/2 -translate-y-1/2 inline-flex items-center justify-center text-xs cursor-default touch-manipulation"
              role="img"
              aria-label="More information"
              onClick={(e) => {
                stopPropagation(e);
                setOpen((prev) => !prev);
              }}
              onPointerDown={stopPropagation}
              onTouchStart={stopPropagation}
            >
              {/* @TODO: Replace with StreamlineIcon — @types/react version mismatch issue expected */}
              <IconWithBackground
                iconName={iconNames.questionMark}
                backgroundColor={COLORS.BRAND_YELLOW_SEVEN}
                className="[&_path]:fill-black"
              />
            </span>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <span className="text-sm">{content}</span>
        </TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
};
